import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './slices/counterSlice'
import globalAudioReducer from './slices/globalAudioSlice'
import audioVersionReducer from './slices/audioVersionSlice'
import flashcardPlaybackReducer from './slices/flashcardPlaybackSlice'
import songReviewSessionReducer from './slices/songReviewSessionSlice'
import { audioCoordinationMiddleware } from './middleware/audioCoordinationMiddleware'
// songReviewAutoSaveMiddleware removed - component handles auto-save with proper debouncing

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    globalAudio: globalAudioReducer,
    audioVersion: audioVersionReducer,
    flashcardPlayback: flashcardPlaybackReducer,
    songReviewSession: songReviewSessionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serialization checks if needed
        ignoredActions: [],
        // Ignore these field paths in all actions
        ignoredActionPaths: [],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }).concat(audioCoordinationMiddleware),
})

// Expose store on window for Playwright tests
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).__REDUX_STORE__ = store
}

// Infer types from the store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store
